<div class="container " style="min-height: 80vh">
  <table mat-table [dataSource]="databaseUsers()" class="mat-elevation-z8">

    <ng-container matColumnDef="database">
      <th mat-header-cell *matHeaderCellDef>User name</th>
      <td mat-cell *matCellDef="let element"> {{ element.name }}</td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th class="" mat-header-cell *matHeaderCellDef></th>
      <td class="" mat-cell *matCellDef="let element">
        <button mat-icon-button type="button" class="" title="Edit user" (click)="onEdit(element)">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button type="button" class="" title="Delete user" (click)="onDelete(element)">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <button class="mt-3" mat-raised-button (click)="openCreateDialog()">
    Create database user
    <mat-icon>add_circle</mat-icon>
  </button>

</div>


